export function withoutDefaults(fn) {
  return fn;
}
//# sourceMappingURL=withoutDefaults.js.map